'use strict';
import axios from 'axios';
import store from 'components/store.js';

//Fetching the data from store.
const GetCustomerQueryParams = () => {

    const state = { ...store.getState() };//avoid bugs with immutable data
    const UserId = parseInt(state.userid);
    const RoleId = parseInt(state.roleId);
    const AccessToken = state.accessToken;

    const queryParams = {
      "role_id": RoleId,
      "user_id": UserId,
      "access_token": AccessToken
    };
    return queryParams;
  }

/*************************************************************************/
/*              APIs for Probe
*************************************************************************/

export const getProbeTypes = () => {
  let urlstr = `/api/customers/admin/probes/inventory/probetypes`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams); 
  return  axios.get(urlstr, 
      {
        headers: {
          'Content-Type': 'application/json',
          data: JSON.stringify(dataQuery)
        }
      })
      .then(resp => resp.data);
}

export const getProbeInventoryList = () => {
  let urlstr = `/api/customers/admin/probes/inventory/list/all`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams); 
  return  axios.get(urlstr, 
      {
        headers: {
          'Content-Type': 'application/json',
          data: JSON.stringify(dataQuery)
        }
      })
      .then(resp => resp.data);
}


export const getProbe = (probeserialnumber) => {
    let urlstr = `/api/customers/admin/probes/inventory/${probeserialnumber}`;
    let queryParams = GetCustomerQueryParams();
    let dataQuery = Object.assign(queryParams); 
    return  axios.get(urlstr, 
        {
          headers: {
            'Content-Type': 'application/json',
            data: JSON.stringify(dataQuery)
          }
        })
        .then(resp => resp.data);
}

export const getProbeModels = () => {
  let urlstr = `/api/customers/admin/probes/modelnames/all`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return  axios.get(urlstr, 
    {
      headers: {
        'Content-Type': 'application/json',
        data: JSON.stringify(dataQuery)
      }
    })
    .then(resp => resp.data);
}

export const addProbe = (probeserialnumber, payload) => {
  let urlstr = `/api/customers/admin/probes/inventory/newentry`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.post(urlstr, payload, {
      headers: {
        'Content-Type': 'application/json',
        data: JSON.stringify(dataQuery),
      }
    })
    .then(resp => resp.data);
}

export const modifyProbe = (probeserialnumber, payload) => {
  let urlstr = `/api/customers/admin/probes/inventory/${probeserialnumber}/modifyentry`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.post(urlstr, payload, {
      headers: {
        'Content-Type': 'application/json',
        data: JSON.stringify(dataQuery),
      }
    })
    .then(resp => resp.data);
}

export const deleteProbe = (probeserialnumber) => {
    let urlstr = `/api/customers/admin/probes/inventory/${probeserialnumber}/delete`;
    let queryParams = GetCustomerQueryParams();
    let dataQuery = Object.assign(queryParams);
    return axios.post(urlstr, {}, {
        headers: {
          'Content-Type': 'application/json',
          data: JSON.stringify(dataQuery),
        }
      })
      .then(resp => resp.data);
}

export const importFile = (file) => {
  let urlstr = `/api/customers/admin/probes/inventory/import`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.post(urlstr, file, {
      headers: {
        'Content-Type': 'multipart/form-data',
        data: JSON.stringify(dataQuery),
      }
    })
    .then(resp => resp.data);
}

